<template>
<div class="content">
  <el-form ref="editForm" label-width="40px" :model="editJson" :rules="rules">
    <!-- 用户名 -->
    <el-form-item label-width="0">
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <div style="margin: 15px 0;"></div>
      <el-checkbox-group v-model="selectGroups" @change="handleCheckedGroupsChange">
        <el-checkbox v-for="group in groups" :key="group.msgObjectType" :label="group.msgObjectType">{{group.remark}}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="备注" prop="remark">
      <el-input v-model="editJson.remark"></el-input>
    </el-form-item>
  </el-form>
  <div class="atb-text-right btn-wrap">
    <!-- 保存 -->
    <el-button class="atb-dialog-confirm" type="primary" @click="submit">{{$t('common.Save')}}</el-button>
    <!-- 取消 -->
    <el-button class="atb-dialog-cancel" type="cancel" @click="$parent.$parent.hide();">{{$t('common.Cancel')}}</el-button>
  </div>
</div>  
</template>
<script>
import editMixin from '@/mixins/edit.mixin'
export default {
  mixins: [ editMixin ],
   props: {
    // 编辑信息
    editData: {
      type: Object,
      default: ()=>{}
    }
  },
  data() {
    return {
      id: 'userId',
      groups: [],
      groupMap: {},
      selectGroups: [],
      editMethod:'post',
      editApi: this.$api.Identity.MsgUser.save,
      isIndeterminate: false
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData() {
    this.$ajax.get(this.$api.Identity.MsgSetting.all).then(res=>{
          this.groups = res.data||[];
          this.groups.forEach(item => {
            this.groupMap[item.msgObjectType] = item;
          });
          this.$ajax.get(this.$api.Identity.MsgUser.all, {WkNo: this.editData.wkNo}).then(res=>{
          res.data && res.data.msgObjectType.split(',').forEach(t => {
            this.groupMap[t] && (this.groupMap[t].unselected = true);
          });
          for (const key in this.groupMap) {
            if (Object.hasOwnProperty.call(this.groupMap, key) && !this.groupMap[key].unselected) {
              this.selectGroups.push(key)
            }
          }

          
          res.data&&this.$set(this.editJson,'remark',res.data.remark);
          this.isIndeterminate = this.selectGroups.length > 0 && this.selectGroups.length < this.groups.length;
          this.checkAll = this.selectGroups.length === this.groups.length;
        })
    }).catch(()=>{})
    },
    resetSubmitParams(){
       const obj={};
       const nodeArr=[];
       this.groups.forEach(v=>{
         if(!this.selectGroups.includes(v.msgObjectType)){
           nodeArr.push(v.msgObjectType);
         }
       });
      obj.wkNo=this.editData.wkNo;
      obj.msgObjectType=nodeArr.join(',');
      obj.remark=this.editJson.remark;
      obj.openId=this.editData.openId;
       return obj;
    },
    handleCheckAllChange(val) {
        this.selectGroups = val ? this.groups.map(row => row.msgObjectType) : [];
        this.isIndeterminate = false;
    },
     handleCheckedGroupsChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.groups.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.groups.length;
      }
  }
}
</script>
